import React, { useState } from 'react';
import { 
    Dialog, DialogTitle, DialogContent, DialogActions, 
    Button, TextField, Rating, Typography, Box, Alert 
} from '@mui/material';
import api from '../services/api'; // Ensure this matches your API path
import { useAuth } from '../context/AuthContext';

const ReviewModal = ({ open, onClose }) => {
    const { token } = useAuth();
    const [rating, setRating] = useState(5);
    const [text, setText] = useState('');
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);

    const handleSubmit = async () => {
        setLoading(true);
        try {
            await api.post('/auth/review', { rating, text }, {
                headers: { Authorization: `Bearer ${token}` }
            });
            setSuccess(true);
            setTimeout(() => {
                setSuccess(false);
                setText('');
                onClose();
            }, 2000);
        } catch (err) {
            alert('Failed to submit review. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
            <DialogTitle>Rate Your Experience</DialogTitle>
            <DialogContent>
                {success ? (
                    <Alert severity="success">Thank you! Your review is pending approval.</Alert>
                ) : (
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 1 }}>
                        <Typography component="legend">How would you rate BrightSparc?</Typography>
                        <Rating
                            name="simple-controlled"
                            value={rating}
                            onChange={(event, newValue) => setRating(newValue)}
                            size="large"
                        />
                        <TextField
                            label="Share your feedback"
                            multiline
                            rows={4}
                            variant="outlined"
                            fullWidth
                            value={text}
                            onChange={(e) => setText(e.target.value)}
                            placeholder="Tell us what you liked or what we can improve..."
                        />
                    </Box>
                )}
            </DialogContent>
            <DialogActions>
                {!success && (
                    <>
                        <Button onClick={onClose} disabled={loading}>Cancel</Button>
                        <Button onClick={handleSubmit} variant="contained" disabled={loading || !text}>
                            {loading ? 'Submitting...' : 'Submit Review'}
                        </Button>
                    </>
                )}
            </DialogActions>
        </Dialog>
    );
};

export default ReviewModal;
